import { Logger, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import MiniCADAPI from './MiniCADAPI';
import { IMPERIAL, METRIC } from './types';

/* the adal configuration export */
const envENV = process.env.REACT_APP_ENVIRONMENT || 'dev';
const applicationConfig = {
  clientID: process.env.REACT_APP_AZURE_B2C_APP_ID || '819dfbc3-1faa-4b97-a01b-ce3b8438d6dc',
  redirectURL: process.env.REACT_APP_REDIRECT_URL || 'http://localhost:3000/',
  authority: 'https://adsciam.ciamlogin.com/adsciam.com', // NEW SSO
  passwordResetAuthority: 'https://adsciam.ciamlogin.com/adsciam.com',
  editProfileAuthority: 'https://adsciam.ciamlogin.com/adsciam.com',
  b2cScopes: ['openid', 'profile'],
  scopes: ['openid', 'profile'],
  knownAuthorities: ['adsb2cad.b2clogin.com'],
};

/* export authentication class */
class Authentication {
  clientApplication;

  constructor() {
    const logger = new Logger(this.loggerCallback, { level: LogLevel.Verbose });
    const config = {
      appId: applicationConfig.clientID,
      redirectUri: applicationConfig.redirectURL,
      scopes: [applicationConfig.scopes],
    };

    let msalConfig = {
      auth: {
        clientId: applicationConfig.clientID,
        authority: applicationConfig.authority,
        knownAuthorities: [applicationConfig.authority],
        validateAuthority: false,
        navigateToLoginRequestUrl: false,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
      },
      system: {
        logger: logger,
      },
    };

    this.clientApplication = new PublicClientApplication(msalConfig);
  }

  loggerCallback(logLevel, message, piiEnabled) {
    console.info(message);
  }

  async editProfile(locale = null) {
    /* set the policy to edit profile */
    this.clientApplication.authority = applicationConfig.editProfileAuthority;
    /* show profile edit window */
    await this.clientApplication.loginPopup(
      applicationConfig.b2cScopes,
      `ui_locales: ${locale && locale.length > 2 ? locale.substring(0, 2) : locale}`,
    );
  }

  async changePassword(locale = null) {
    /*const confRequest = {
        scopes: [],
        ui_locales: `${(locale && locale.length > 2 ? locale.substring(0, 2) : locale)}`
    };
    await this.clientApplication.loginPopup({
        authority: applicationConfig.passwordResetAuthority
    });*/
  }

  async login(locale = null) {
    try {
      const confRequest = {
        scopes: applicationConfig.scopes,
        prompt: 'select_account', // This will show the registration link
        authority: applicationConfig.authority,
      };

      let idToken = await this.clientApplication.loginPopup(confRequest);

      const accounts = this.clientApplication.getAllAccounts();

      let accessToken = await this.clientApplication.acquireTokenSilent({
        scopes: applicationConfig.scopes,
        account: accounts[0],
      });

      let user,
        resourcesTokens,
        userData = null;
      try {
        let userIdTokenClaims = accessToken.idTokenClaims;

        console.log('accessToken info:', accessToken);

        //         info.resourcesTokens.users.adToken,
        //             info.accessToken.uniqueId
        user = await MiniCADAPI.getB2CUser(accessToken.accessToken, accessToken.uniqueId);

        console.log('user2:', user);

        resourcesTokens = await MiniCADAPI.getResourcesTokens(idToken.idToken, user.mail, accessToken.accessToken);

        let userRec = await MiniCADAPI.getUserRecord(user.id, resourcesTokens.users.tableToken);
        let protectUnit = METRIC;
        if (userRec.unit) {
          protectUnit = userRec.unit._;
        } else {
          if (userRec.region === 'usa') {
            protectUnit = IMPERIAL;
          }
        }

        if (userRec && userRec.region && userRec.language) {
          userData = {
            region: userRec.region._,
            language: userRec.language._,
            unit: protectUnit,
          };
          if (!userRec.unit) {
            await this.updateUserLocaleData({
              user,
              idToken,
              accessToken,
              resourcesTokens,
              userData,
              accounts,
            });
          }
        }
      } catch (ex) {
        console.log('Unable to retrieve userdata record:', ex);
      }
      return { user, idToken: idToken.idToken, accessToken, resourcesTokens, userData, accounts };
    } catch (exception) {
      await this.handleAuthException(exception, locale, 'login()');
    }
  }

  async loadFromCache(locale = null) {
    try {
      console.log('loadFromCache()');
      const accounts = await this.clientApplication.getAllAccounts();

      if (accounts.length !== 1) {
        console.error('accounts.length !== 1')
        //return;
      }

      let account = accounts[0]; //homeAccountId

      let accessToken = await this.clientApplication
        .acquireTokenSilent({
          scopes: applicationConfig.scopes,
          account: accounts[0]
        });

      let uAccount  = await MiniCADAPI.getB2CUser(accessToken.accessToken, accessToken.uniqueId)



      let raw_user;

      if (account) {
        raw_user = {
          emails: [account.username],
          oid: account.localAccountId
        };
      }

      if (uAccount) {
        raw_user = {
          email: uAccount.mail,
          id: uAccount.id
        };
      }

      let user = null;
      let idToken = null;
      let resourcesTokens = null;

      if (raw_user) {
        accessToken = await this.clientApplication
          .acquireTokenSilent({
            scopes: applicationConfig.scopes,
            account: accounts[0]
          });
        user = uAccount;
        idToken = accessToken.idToken;

      }
      if (user && idToken && accessToken) {
        resourcesTokens = await MiniCADAPI.getResourcesTokens(
          idToken.idToken,
          user.mail,
          accessToken.accessToken
        );
        let userData = null;
        try {
          let userRec = await MiniCADAPI.getUserRecord(user.id, resourcesTokens.users.tableToken);
          let protectUnit = METRIC;
          if (userRec.unit) {
            protectUnit = userRec.unit._;
          } else {
            if (userRec.region === 'usa') {
              protectUnit = IMPERIAL;
            }
          }

          if (userRec && userRec.region && userRec.language) {
            userData = {
              region: userRec.region._,
              language: userRec.language._,
              unit: protectUnit,
            };
            if (!userRec.unit) {
              const _user = await this.updateUserLocaleData({
                user,
                idToken,
                accessToken,
                resourcesTokens,
                userData,
                accounts,
              });
              console.log('_user', _user);
            }
          }
        } catch (ex) {
          console.log('Unable to retrieve userdata record:', ex);
        }
        return { user, idToken, accessToken, resourcesTokens, userData, accounts };
      } else {
        return null;
      }
    } catch (exception) {
      await this.handleAuthException(exception, locale, 'loadFromCache()');
    }
  }

  async updateUserLocaleData(userInfo) {
    try {
      if (userInfo.userData) {
        let unitBasedOnnRegion = METRIC;
        if (userInfo.userData.region === 'usa') {
          unitBasedOnnRegion = IMPERIAL;
        }
        await MiniCADAPI.upsertUserRecord(
          {
            userId: userInfo.user.id,
            regionId: userInfo.userData.region,
            languageId: userInfo.userData.language,
            unit: unitBasedOnnRegion,
          },
          userInfo.resourcesTokens.users.tableToken,
        );
      }
    } catch (error) {
      console.info(`At updateUserLocaleData() ${error.message}`);
    }
    return userInfo;
  }

  async logout(locale = null) {
    try {
      this.clientApplication.logout();
    } catch (exception) {
      await this.handleAuthException(exception, locale, 'logout()');
    }
  }

  async handleAuthException(exception, locale, exFrom) {
    if (exception.errorCode === 'access_denied' && exception.errorMessage.indexOf('AADB2C90118') > -1) {
      await this.changePassword(locale);
      return await this.login(locale);
    } else if (exception.errorCode === 'access_denied' && exception.errorMessage.indexOf('AADB2C90091') > -1) {
      console.info('access_denied action :: The user has cancelled entering self-asserted information');
    } else if (exception.errorCode === 'interaction_required' && exception.errorMessage.indexOf('AADB2C90077') > -1) {
      // This code was placed to capture the problem on re-authentication that crashed the system
      console.info('interaction_required action :: User does not have an existing session, logging out the user');
      this.clientApplication.logout();
    } else if (exception.errorCode === 'no_tokens_found') {
      // This code was placed to capture the problem on re-authentication that crashed the system
      console.info('no_tokens_found :: No good token found, logging out');
      this.clientApplication.logout();
    } else if (exception.errorCode === 'user_cancelled') {
      console.info('user_cancelled action');
    } else if (exception.errorCode === 'interaction_in_progress') {
      console.info('interaction_in_progress :: Interaction already in progress, logging out the user');
      this.clientApplication.logout();
    } else {
      console.warn(`You might need to re-login`);
      console.warn(`Authentication.js ${exFrom} :: ${exception.message}`);
      throw exception;
    }
  }

  async getSpecificUserReadTokens(idToken, user, accessToken, otherUserOID) {
    /* get the user specific tokens */
    return await MiniCADAPI.getInternalResourcesTokens(idToken, user.mail, accessToken, otherUserOID);
  }
}

/* export authentication object */
export const auth = new Authentication();



// WEBPACK FOOTER //
// ./src/lib/authentication.js